module.exports = __webpack_public_path__ + "static/media/itv-logo-charcoal.66381190.svg";